import React from 'react';
import { useUserClients } from '../../contexts/UserClientsContext';
import { NavBar } from '../../Modules/Navigation/components/NavBar/NavBar';
import ClientSongCollections from '../../Modules/SongCollection/features/ClientSongCollections/ClientSongCollections';
import LoadingSpinner from '../../SharedComponents/LoadingSpinner/LoadingSpinner';
import styles from './ClientPages.module.css';

const ClientSongCollectionsPage = () => {
    const { selectedClient, clientsInitialized, hasErrorLoadingClients } = useUserClients();

    return (
        <>
            <NavBar />
            {clientsInitialized && selectedClient && (
                <ClientSongCollections key={selectedClient.id} clientId={selectedClient.id} />
            )}
            {!clientsInitialized && hasErrorLoadingClients && (
                <div className={styles.errorMessage}>Sorry, we're experiencing technical issues</div>
            )}
            {!clientsInitialized && !hasErrorLoadingClients && <LoadingSpinner spinnerClassName={styles.spinner} />}
        </>
    );
};

export default ClientSongCollectionsPage;
